class NiokySolidOffers extends HTMLElement {
  connectedCallback() {
    this.onChange = () => {
      const selected = this.querySelector('input:checked');
      const form = this.closest('product-form');
      if (!selected || !form) return;
      form.querySelectorAll('input[name="id"]').forEach(input => { input.value = selected.dataset.variantId; });
      const container = form.querySelector('[data-ref="add-to-cart-button-container"]');
      if (container) container.dataset.price = selected.dataset.price;
      this.querySelectorAll('.nk-offer').forEach(label => label.classList.toggle('is-selected',label.contains(selected)));
    };
    this.addEventListener('change',this.onChange);
    this.onChange();
  }
  disconnectedCallback() { this.removeEventListener('change',this.onChange); }
}
if (!customElements.get('nioky-solid-offers')) customElements.define('nioky-solid-offers',NiokySolidOffers);
